import React, { useState } from "react";
import Image from "next/image";
import Link from "next/link";
export const JobCard = ({ title, location, type, description, slug }) => {
    const [open, setOpen] = useState(false);
    return (
        <div className="border-b border-[#D9D9D9] py-8">
            <div className="flex gap-4 justify-between items-center flex-shrink-0">
                <h2 className="font-medium capitalize text-[14px] lg:text-[16px] xl:text-[18px]  leading-[24px] lg:leading-[30px] w-[30%] lg:w-[20%]">
                    {title}
                </h2>

                <div className="flex gap-8 lg:gap-40">
                    <h6 className="text-[14px] lg:text-[16px] font-normal leading-[24px] lg:leading-[30px] text-gray w-[100px] lg:w-[250px]">
                        {location}
                    </h6>
                    <span className="text-[14px] lg:text-[16px] font-normal text-gray ">
                        {type === "fulltime" ? "Full Time" : "Part Time"}
                    </span>
                </div>
                <div className="cursor-pointer text-primary pr-4">
                    {!open ? (
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="w-5 h-5"
                            onClick={() => {
                                setOpen(true);
                            }}
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M12 4.5v15m7.5-7.5h-15"
                            />
                        </svg>
                    ) : (
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="w-5 h-5"
                            onClick={() => {
                                setOpen(false);
                            }}
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M5 12h14"
                            />
                        </svg>
                    )}
                </div>
            </div>
            {open ? (
                <div className="mt-4 flex flex-col gap-5 text-[14px] lg:text-[16px] xl:text-[18px] ">
                    <p className="">{description}</p>
                    <Link
                        href={`/life-at-hindustan-power/${slug}`}
                        className="flex gap-2 items-center text-red underline underline-offset-4"
                    >
                        <span>Apply Now</span>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="w-4 h-4"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="m8.25 4.5 7.5 7.5-7.5 7.5"
                            />
                        </svg>
                    </Link>
                </div>
            ) : null}
        </div>
    );
};
